'use strict';

var AppState = require('app_state');
var utils = require('components/devices/views/controller/handling_view_utils');
var Svg = require('utils/svg');
var Strings = require('utils/strings');
var i18n = require('utils/i18n');
var Decorator = require('utils/decoration');

// temperaturView displays a thermometer showing the configured temperature.
var TemperatureDialogView = Backbone.Marionette.ItemView.extend({
    template: require('components/devices/templates/controller/temp_regulation'),

    //constant params
    accuracy: 10, // The displayed accuracy of the temperature (10=1 position after decimal point)
    tempStepSize: 5, // The step size in °C when clicked on the plus- or minus-button

    // window-size-dependent parameters
    svgOffset: undefined, // distance between the upper border of the svg to the upper screen-border
    scale: undefined, // scaling of the svg
    // svg-specific constants
    svgLowerBound: 190, // intrinsic bounds for the draggable elements of the svg (screensize INdependend)
    svgUpperBound: 10,

    ui: {
        save: '#js-save',
        plus: '#js-plus',
        minus: '#js-minus',
        label: '#svg-group-handle',
        labelText: '.temp-label',
        thermometerFilling: '#svg-temperature',
        thermometer: '#svg-thermometer',
        sunGroup: '#svg-sun-group',
        moonGroup: '#svg-moon-group',
        sun: '#svg-sun',
        moon: '#svg-moon',
        time: '#js-validity-time',
        btnClearTime: '#js-clear-validity',
        btnEditTime: '#js-edit-validity',
    },

    events: {
        'mousedown @ui.label': 'draggingControl',
        'touchstart @ui.label': 'draggingControl',
        'mousedown @ui.thermometerFilling': 'draggingControl',
        'touchstart @ui.thermometerFilling': 'draggingControl',
        'click @ui.save': 'saveClicked',
        'click @ui.plus': 'plusMinusClicked',
        'click @ui.minus': 'plusMinusClicked',
        'click @ui.btnClearTime': 'clearTime',
        'click @ui.btnEditTime': 'editTime',
    },

    initialize: function (options) {
        // make sure, events are removed, when modal is hidden
        $(document).on('hidden.bs.modal', this.removeCustomEvents);

        this.controller = options.controller;
        this.handleView = options.handleView;
        this.mode = parseInt(options.mode.substring(3));

        this.activeTemp = this.model.attributes.temperatures[this.mode].data;
        this.autoTimer =
            this.model.attributes.auto_timer > 0
                ? moment().add(this.model.attributes.auto_timer, 'minutes')
                : moment().add(4, 'hours');
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);

        data.mode = this.mode;
        data.title = i18n.TR(data.temperatures[this.mode].name);
        data.auto_timer_disabled = this.model.attributes.circuitID == 90;
        data.auto_timer_string = this.autoTimer ? this.autoTimer.format('DD.MM.YYYY HH:mm') : undefined;

        data.base_color = AppState.style[1];

        data.buttonReleasedConfig = {
            x: 270,
            y: 0,
            size: '0.7',
            text: Strings.fixedPoint(this.activeTemp, 1) + '°C',
            id: 'temp-button-released',
            class: 'temp-label',
        };
        data.buttonPressedConfig = {
            x: 270,
            y: 0,
            size: '0.7',
            text: Strings.fixedPoint(this.activeTemp, 1) + '°C',
            id: 'temp-button-pressed',
            class: 'temp-label',
        };

        return data;
    },

    initializeDatePicker: function (timer) {
        var self = this;
        utils.initializeDatePicker(this.ui.time, timer, 'up', function (start, end, label) {
            self.autoTimer = start;
            self.render();
        });
    },

    clearTime: function () {
        this.autoTimer = undefined;
        this.render();
    },

    editTime: function () {
        this.ui.time.data('daterangepicker').toggle();
    },

    initializeUiElements: function () {
        var dayTemperature = this.model.attributes.temperatures[1].data;
        var nightTemperature = this.model.attributes.temperatures[2].data;

        // initialize sun and moon position
        if (this.mode !== 2) {
            this.svgMoveElement(this.ui.moonGroup[0], nightTemperature);
        }
        if (this.mode !== 1) {
            this.svgMoveElement(this.ui.sunGroup[0], dayTemperature);
        }
        if (dayTemperature < nightTemperature) {
            this.ui.sun.attr('transform', 'translate(40,33) scale(.01)');
            this.ui.moon.attr('transform', 'translate(42 18) scale(.01) rotate(-50)');
        }

        // initialize label
        // invalid active temperature? -> initialize with minimal temperature
        if (this.activeTemp === 32767) {
            this.activeTemp = this.model.attributes.t_min;
            this.ui.labelText.text('--');
        } else {
            this.ui.labelText.text(Strings.fixedPoint(this.activeTemp, 1) + '°');
        }
        var visualizedTemp = Math.max(this.activeTemp, this.model.attributes.t_min);
        this.ui.label.attr('transform', 'translate(0,' + this.tempToSVGPos(visualizedTemp) + ')');

        // initialize filling
        this.ui.thermometerFilling.attr('height', this.tempToSVGPos(visualizedTemp));
        // setting the thermometers fill-color
        this.ui.thermometer.attr(
            'fill',
            Svg.temperatureToRGBcolor(visualizedTemp, this.model.attributes.t_max, this.model.attributes.t_min)
        );
    },

    onRender: function () {
        this.initializeUiElements();
        this.initializeDatePicker(this.autoTimer);
    },

    // initialize the svg-graphic
    onAttach: function () {
        // identify and set the scaling and offset of the svg
        $(window).on('resize.modal-body', this.setWindowParams);

        this.initializeUiElements();
    },

    removeCustomEvents: function () {
        $(window).off('resize.modal-body', this.setWindowParams);
        $(document).off('hidden.bs.modal', this.removeCustomEvents);
    },

    plusMinusClicked: function (e) {
        var temp = this.activeTemp;

        switch ($(e.currentTarget).attr('id')) {
            case 'js-minus':
                temp -= this.tempStepSize;
                break;
            case 'js-plus':
                temp += this.tempStepSize;
                break;
        }
        this.updateGraphic(temp);
    },

    // updateGraphic changes the fill-hight, fill-color, label-hight
    // and label-content of the graphic in function of a given temperature
    updateGraphic: function (temp) {
        temp = Math.floor(temp / 5) * 5;
        temp = this.restrictToTempRange(temp);
        this.activeTemp = temp;

        //setting the fill-height of the thermometer
        this.ui.thermometerFilling.attr('height', this.tempToSVGPos(temp));

        //setting the label-height
        this.ui.label.attr('transform', 'translate(0,' + this.tempToSVGPos(temp) + ')');

        //setting label-content
        this.ui.labelText.text(Strings.fixedPoint(this.activeTemp, 1) + '°');

        //setting the thermometers fill-color
        this.ui.thermometer.attr(
            'fill',
            Svg.temperatureToRGBcolor(temp, this.model.attributes.t_max, this.model.attributes.t_min)
        );
    },

    // draggingControl manages the dragging event and calls updateGraphic when appropriated
    draggingControl: function (event) {
        this.setWindowParams();
        var view = this;
        var startPosition = event.pageY || event.originalEvent.touches[0].pageY;

        function cleanUp(e) {
            $(document).off('mousemove touchmove', this.updateGraphic);
            $(document).off('mouseup touchend', cleanUp);
            $('#temp-button-pressed').hide();
            $('#temp-button-released').show();
            return;
        }

        function startUp(e) {
            $('#temp-button-pressed').show();
            $('#temp-button-released').hide();
            return;
        }

        $(document).on('mousemove touchmove', function (e) {
            var yMovement = e.pageY || e.originalEvent.touches[0].pageY;
            var temp = view.svgPosToTemp((yMovement - view.svgOffset) * view.scale);
            view.updateGraphic(temp);
        });
        $(document).on('mouseup touchend', cleanUp);
        $(document).on('mousedown touchstart', startUp);
    },

    saveClicked: function (event) {
        event.preventDefault();

        var validity_minutes = this.autoTimer ? Math.max(this.autoTimer.diff(moment(), 'minutes'), 0) : 0;
        validity_minutes = Math.min(validity_minutes, 65535);

        var temperatures = $.extend(true, [], this.model.attributes.temperatures);
        temperatures[this.mode].data = this.activeTemp;
        Decorator.disableElement('.modal-dialog');
        this.handleView.saveModel(
            {
                auto_timer: validity_minutes,
                temperatures: temperatures,
                changedValue: 'temperature_' + this.mode,
            },
            i18n.TR('Temperatur wurde erfolgreich gespeichert'),
            i18n.TR('Temperatur konnte nicht gespeichert werden.')
        );
    },

    svgMoveElement: function (element, temp) {
        element.setAttribute('viewBox', '0 ' + (-this.tempToSVGPos(temp) + 8) + ' 400 300');
    },

    // cut off values, that exeed the temperature limits and returns the rounded value
    restrictToTempRange: function (temp) {
        temp = Math.max(this.model.attributes.t_min, Math.min(temp, this.model.attributes.t_max));
        return Math.round(temp * this.accuracy) / this.accuracy;
    },

    setWindowParams: function () {
        this.scale = 300 / $('#svg-container').height();
        this.svgOffset = $('#svg-container').offset().top + 20 / this.scale;
    },

    tempToSVGPos: function (temp) {
        return (
            ((this.svgLowerBound - this.svgUpperBound) / (this.model.attributes.t_min - this.model.attributes.t_max)) *
                (temp - this.model.attributes.t_max) +
            this.svgUpperBound
        );
    },

    svgPosToTemp: function (pos) {
        var temp =
            this.model.attributes.t_max +
            ((pos - this.svgUpperBound) * (this.model.attributes.t_min - this.model.attributes.t_max)) /
                (this.svgLowerBound - this.svgUpperBound);

        return Math.round(temp);
    },
});

module.exports = TemperatureDialogView;
